export default __webpack_public_path__ + "assets/info.231d8799.svg";